import { render, staticRenderFns } from "./ProductionNotUsed.vue?vue&type=template&id=35c7b216&scoped=true&"
import script from "./ProductionNotUsed.vue?vue&type=script&lang=js&"
export * from "./ProductionNotUsed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c7b216",
  null
  
)

export default component.exports